import React,{useState,useEffect} from 'react'
import Loader from '../components/Loader'
import Message from '../components/Message'
import FormContainer from '../components/FormContainer'
import {Row,Col,Form,Button} from 'react-bootstrap'
import {Link} from 'react-router-dom'

import {useDispatch,useSelector} from 'react-redux'
import {getUserDetails,updateUserProfile } from '../actions/userActions'
import {USER_UPDATE_PROFILE_RESET} from '../constants/userConstants'

function ProfileScreen({history}) {

    const [name,setName]  = useState('')
    const [password,setPassword] = useState('')
    const [confirmPassword,setConfirmPassword] = useState('')
    const [message,setMessage] = useState('')
    const [message_update,setMessage_update] = useState('')

    const dispatch = useDispatch()

    const userDetails = useSelector(state=>state.userDetails)
    const {error,loading,user} = userDetails

    const userLogin = useSelector(state=>state.userLogin)
    const {userInfo} = userLogin

    const userUpdateProfile = useSelector(state=>state.userUpdateProfile)
    const {success} = userUpdateProfile

    useEffect(() => {
        //如果沒有userInfo 就會直接導來login頁面
        if(!userInfo){
            history.push('/login')
        }else{
            // user 從這裡來的 details裡面的state來的
            //const userDetailsReducer = (state = {user:{}},action)=>{
            if(!user || !user.username || success){
                if (success == true){
                    setMessage_update('Update success')
                    setMessage('')
                    setPassword('')
                    setConfirmPassword('')

                }
                dispatch({ type:USER_UPDATE_PROFILE_RESET })
                dispatch(getUserDetails('profile'))
                
            }else{
                setName(user.first_name)
                //setMessage_update('')
            }
       
        }
    }, [userInfo,history,dispatch,user,success])

    const submitHandler = (e) =>{
        e.preventDefault()
        if (password != confirmPassword ){
            setMessage_update('')
            setMessage('Passwords do not match')
        }else{
            //console.log('Updating...')
            dispatch(updateUserProfile({
                'id': user._id,
                'name':name,
                'password':password
            }))
        }
    }
  

    return (
        <FormContainer >

            <Col sm={12} md={12} id="login_page">
                <h2 style={{color:"gray"}}>個人檔案</h2>
                {message_update && <Message variant='info'>{message_update}</Message>}
                {message && <Message variant='danger'>{message}</Message>}
                {error && <Message variant='danger'>{error}</Message> }
                {loading && <Loader/>}
                <Form onSubmit={submitHandler}>

                    <Form.Group controlId="name" style={{marginBottom:"20px"}}>
                        <Form.Label style={{WebkitTextStroke: "0.5px gray"}}>名稱</Form.Label>
                        <Form.Control
                            required
                            type= "name"
                            placeholder="Enter name"
                            value={name}
                            onChange={(e)=>setName(e.target.value)}
                        >
                        </Form.Control>
                    </Form.Group>

                    <Form.Group controlId="password" style={{marginBottom:"20px"}}>
                        <Form.Label style={{WebkitTextStroke: "0.5px gray"}}>更改密碼</Form.Label>
                        <Form.Control
                            type= "password"
                            placeholder="Enter password"
                            value={password}
                            onChange={(e)=>setPassword(e.target.value)}
                        >   

                        </Form.Control>
                    </Form.Group>


                    <Form.Group controlId="passwordConfirm" style={{marginBottom:"20px"}}>
                        <Form.Label style={{WebkitTextStroke: "0.5px gray"}}>確認密碼</Form.Label>
                        <Form.Control
                            type= "password"
                            placeholder="Confirm password"
                            value={confirmPassword}
                            onChange={(e)=>setConfirmPassword(e.target.value)}
                        >
                        </Form.Control>
                    </Form.Group>

                    <Button type="submit" variant="primary" style={{marginBottom:"20px"}}>
                        更新
                    </Button>

                </Form>
            </Col>



        </FormContainer>
    )
}

export default ProfileScreen
